// Packages
import React from 'react';
import PropTypes from 'prop-types';
const Slider = require('react-slick').default;
import { translate } from 'react-i18next';

// Strings
const classPrefix = 'content-carousel';
// const breakPoints = [640, 850, 1060, 1250, 1560, 1870, 10000];
// const showSlides = [3, 3, 3, 3, 3, 3, 3];
// const breakPoints = [1460, 1560, 1750, 10000];
// const showSlides = [1, 3, 1, 3];

export class CarouselFeatured extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.refs && this.refs.slider && this.refs.slider.innerSlider && this.refs.slider.innerSlider.slickGoTo) {
            window.setTimeout(() => { this.refs.slider.innerSlider.slickGoTo(this.calculateInitialPage()); }, 1000);
        }
    }

    calculateInitialPage() {
        let initialSlide;
        switch (this.props.details.length) {
        case 1:
            initialSlide = 0;
            break;
        case 2:
            initialSlide = 1;
            break;
        case 3:
            initialSlide = 1;
            break;
        case 4:
            initialSlide = 2;
            break;
        case 5:
            initialSlide = 2;
            break;
        default:
            initialSlide = 0;
            break;
        }
        return initialSlide;
    }
    makeSlideCarouselSettings(type) {
        const self = this;
        // const settingsResponsive = [{breakpoint: breakPoints[0],
        //     settings: { slidesToShow: showSlides[0]}}, {breakpoint: breakPoints[1],
        //     settings: { slidesToShow: showSlides[1]}}, {breakpoint: breakPoints[2],
        //     settings: { slidesToShow: showSlides[2]}}, {breakpoint: breakPoints[3],
        //     settings: { slidesToShow: showSlides[3]}}];
        return {
            arrows: false,
            className: `${classPrefix}-featured`,
            dots: (self.props.details.length > 1),
            infinite: (self.props.details.length > 3),
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            autoplay: (self.props.details.length > 3),
            autoplaySpeed: 6000,
            variableWidth: true
        };
    }
    render() {
        const settings = this.makeSlideCarouselSettings(this.props.carouselType);
        return (
            <div className="featuredwrapper">
                <div className="featuredcontainer_headers">
                    <div className="featuredcontainer_title">{this.props.title}</div>
                </div>
                <Slider ref="slider" {...settings}>
                 {this.props.details}
                </Slider>
            </div>
        );
    }
}

CarouselFeatured.propTypes = {
    title: PropTypes.string,
    details: PropTypes.array,
    carouselType: PropTypes.string,
    markerHighilightColor: PropTypes.string,
    markerColor: PropTypes.string
};

export default (translate(['translation'])(CarouselFeatured));



// WEBPACK FOOTER //
// ./src/components/carousels/carousel-featured.js